export const MAX_SCORE = 12
